var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._b({staticClass:"custom-select-menu"},'section',_vm.$attrs,false),[_c('div',{staticClass:"select-menu",class:{
      'select-menu--open': _vm.menuOpened,
      'select-menu--form': _vm.formStyle,
      'select-menu--selected': _vm.value,
      '-transparent': _vm.transparent,
      '-error': _vm.error,
      '-error-highlight': _vm.error && _vm.highlightError,
      '-secondary': _vm.secondary,
      '-is-filter': _vm.isFilter
    },on:{"click":_vm.toggleMenu}},[(_vm.$mobileCheck() && _vm.isFilter)?_c('div',{staticClass:"select-menu__filter-icon"},[_c('FilterIcon',{attrs:{"color":!_vm.menuOpened ? '#92A2B0' : '#3E24D6'}})],1):[(_vm.showQtdSelected && _vm.qtdSelected > 0)?_c('div',{staticClass:"select-menu_counter-selected"},[_c('span',[_vm._v(_vm._s(_vm.qtdSelected))])]):_vm._e(),_c('span',{staticClass:"select-menu__text",class:{
          'select-menu__text--placeholder': !_vm.value,
          selected: _vm.qtdSelected > 0
        }},[_vm._v("\n        "+_vm._s(_vm.value ? _vm.value : _vm.placeholder)+"\n      ")]),_c('span',{class:("select-menu__icon icon-dropdown-icon-" + (_vm.menuOpened ? 'up' : 'down'))})]],2)])}
var staticRenderFns = []

export { render, staticRenderFns }